import React from 'react';
import {FormattedMessage} from 'react-intl';

import {
    IconAtom,
    IconBasket,
    IconBellRinging,
    IconBorderAll,
    IconBorderRadius,
    IconBoxMultiple,
    IconBrandChrome,
    IconBrandGravatar,
    IconBrush,
    IconBug,
    IconCalendar,
    IconChartArcs,
    IconChartCandle,
    IconChartInfographic,
    IconCircle,
    IconCircleOff,
    IconClipboardList,
    IconDashboard,
    IconDeviceAnalytics,
    IconFiles,
    IconForms,
    IconHelp,
    IconId,
    IconKey,
    IconLayoutList,
    IconLoader,
    IconLockAccess,
    IconMail,
    IconMenu,
    IconMessages,
    IconNfc,
    IconPalette,
    IconPencil,
    IconPhoneCall,
    IconPictureInPicture,
    IconReceipt2,
    IconRun,
    IconShadow,
    IconShape,
    IconShieldLock,
    IconSitemap,
    IconTools,
    IconTypography,
    IconUser,
    IconUserCheck,

    IconReportMoney,
    IconFileText,
    IconHistory,
    IconBuildingWarehouse,
    IconBuildingBank,
    IconChartBar,
    IconBuildingSkyscraper,
    IconReportAnalytics
    
} from '@tabler/icons';

const icons = {
    IconReportAnalytics:IconReportAnalytics,
    IconBuildingSkyscraper:IconBuildingSkyscraper,
    IconChartCandle:IconChartCandle,
    IconChartBar:IconChartBar,
    IconBuildingBank:IconBuildingBank,
    IconBuildingWarehouse:IconBuildingWarehouse,
    IconHistory:IconHistory,
    IconFileText:IconFileText,
    IconReportMoney:IconReportMoney,
    IconDashboard: IconDashboard,
    IconDeviceAnalytics,

    IconChartArcs: IconChartArcs,
    IconClipboardList: IconClipboardList,
    IconChartInfographic: IconChartInfographic,

    IconForms: IconForms,
    IconReceipt2: IconReceipt2,
    IconPencil: IconPencil,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconPhoneCall: IconPhoneCall,
    IconBrandChrome: IconBrandChrome,
    IconFiles: IconFiles,
    IconAtom: IconAtom,
    IconTools: IconTools,
    IconBrush: IconBrush,
    IconLockAccess: IconLockAccess,
    IconShieldLock: IconShieldLock,
    IconKey: IconKey,
    IconTypography: IconTypography,
    IconMenu: IconMenu,
    IconBoxMultiple: IconBoxMultiple,
    IconCircleOff: IconCircleOff,
    IconCircle: IconCircle,
    IconBorderRadius: IconBorderRadius,
    IconBrandGravatar: IconBrandGravatar,
    IconShape: IconShape,
    IconUserCheck: IconUserCheck,
    IconId: IconId,
    IconLayoutList: IconLayoutList,
    IconBug: IconBug,
    IconLoader: IconLoader,
    IconRun: IconRun,
    IconUser: IconUser,
    IconHelp: IconHelp,
    IconSitemap: IconSitemap,
    IconPictureInPicture: IconPictureInPicture,
    IconMail: IconMail,
    IconMessages: IconMessages,
    IconNfc: IconNfc,
    IconCalendar: IconCalendar,
    IconBellRinging: IconBellRinging,
    IconBorderAll: IconBorderAll,
    IconChartCandle: IconChartCandle,
    IconBasket: IconBasket,
    
};

const menuItems = {
    items: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'group',
            children: [
                {
                    id: 'dash-default',
                    title: <FormattedMessage id="default" />,
                    type: 'item',
                    url: '/home/dashboard/default',
                    icon: icons['IconDashboard'],
                    breadcrumbs: false,
                    auth: ['public']
                }
            ]
        },
        {
            id: 'manager',
            title: <FormattedMessage id="manager" />,
            type: 'group',
            children: [
                {
                    id: 'customers',
                    title: <FormattedMessage id="customers" />,
                    type: 'item',
                    url: '/home/khachhang',
                    icon: icons['IconReportMoney'],
                    breadcrumbs: false,
                    auth: ['/cus/khachhang/getall','/cus/personal/khachhang/getall']
                },
                {
                    id: 'contracts',
                    title: <FormattedMessage id="contracts" />,
                    type: 'item',
                    url: '/home/hopdong',
                    icon: icons['IconClipboardList'],
                    breadcrumbs: false,
                    auth: ['/cus/hopdong/getall','/cus/personal/hopdong/getall']
                },
                {
                    id: 'service',
                    title: <FormattedMessage id="service" />,
                    type: 'item',
                    url: '/home/dichvu',
                    icon: icons['IconTools'],
                    breadcrumbs: false,
                    auth: ['/cus/dichvu/getall']
                },
                {
                    id: 'recommend',
                    title: <FormattedMessage id="recommend" />,
                    type: 'item',
                    url: '/home/dexuat',
                    icon: icons['IconMenu'],
                    breadcrumbs: false,
                    auth: ['/cus/dichvu/getall']
                }
               
            ]
        },
        {
            id: 'statistic',
            title: <FormattedMessage id="statistic" />,
            type: 'group',
            children: [
                {
                    id: 'statistics-by-customer',
                    title: <FormattedMessage id="statistics-by-customer" />,
                    type: 'item',
                    url: '/home/statistic/customer',
                    icon: icons['IconChartBar'],
                    breadcrumbs: false,
                    auth: ['/cus/thongke/khachhangkhaosat/**','/cus/personal/thongke/khachhangkhaosat/**']
                },
                {
                    id: 'statistics-by-units',
                    title: <FormattedMessage id="statistics-by-units" />,
                    type: 'item',
                    url: '/home/statistic/unit',
                    icon: icons['IconReportAnalytics'],
                    breadcrumbs: false,
                    auth: ['/cus/dashboard/default/**']
                },
               
                {
                    id: 'statistics-by-marketshare',
                    title: <FormattedMessage id="statistics-by-marketshare" />,
                    type: 'item',
                    url: '/home/statistic/marketshare',
                    icon: icons['IconDeviceAnalytics'],
                    breadcrumbs: false,
                    auth: ['/cus/dichvu/thongkethiphan']
                }
            ]
        },
        {
            id: 'categoria',
            title: <FormattedMessage id="categoria" />,
            type: 'group',
            children: [
                {
                    id: 'staff',
                    title: <FormattedMessage id="staff" />,
                    type: 'item',
                    url: '/home/nhanvien',
                    icon: icons['IconUser'],
                    breadcrumbs: false,
                    auth: ['/cus/nhanvien/getall','/cus/personal/nhanvien/getall']
                },
                {
                    id: 'manager-unit',
                    title: <FormattedMessage id="manager-unit" />,
                    type: 'item',
                    url: '/home/donvi',
                    icon: icons['IconBuildingWarehouse'],
                    breadcrumbs: false,
                    auth: ['/cus/donvi/getall']
                },
                // {
                //     id: 'manager-center',
                //     title: <FormattedMessage id="manager-center" />,
                //     type: 'item',
                //     url: '/home/trungtam',
                //     icon: icons['IconBuildingSkyscraper'],
                //     breadcrumbs: false,
                //     auth: ['/cus/trungtam/getall']
                // },
                {
                    id: 'administrative-units',
                    title: <FormattedMessage id="administrative-units" />,
                    type: 'item',
                    url: '/home/dvhc',
                    icon: icons['IconBuildingBank'],
                    breadcrumbs: false,
                    auth: ['/cus/dvhc/getall']
                }
            ]
        },
        {
            id: 'program',
            title: <FormattedMessage id="program" />,
            type: 'group',
            children: [
               
                {
                    id: 'access-permissions',
                    title: <FormattedMessage id="access-permissions" />,
                    type: 'collapse',
                    icon: icons['IconPencil'],
                    children: [
                        {
                            id: 'role-leader',
                            title: <FormattedMessage id="role-leader" />,
                            type: 'item',
                            url: '/home',
                            value: 'ROLE_LANHDAO',
                            modal:true
                        },
                        {
                            id: 'role-manager',
                            title: <FormattedMessage id="role-manager" />,
                            type: 'item',
                            url: '/home',
                            value: 'ROLE_QUANLY',
                            modal:true
                        },
                        {
                            id: 'role-manager2',
                            title: <FormattedMessage id="role-manager2" />,
                            type: 'item',
                            url: '/home',
                            value: 'ROLE_TRUONGPHONG',
                            modal:true
                        },
                        {
                            id: 'role-staff',
                            title: <FormattedMessage id="role-staff" />,
                            type: 'item',
                            url: '/home',
                            value: 'ROLE_NHANVIEN',
                            modal:true
                        }
                    ]
                },
                {
                    id: 'operation-history',
                    title: <FormattedMessage id="operation-history" />,
                    type: 'item',
                    url: '/home/history/all',
                    icon: icons['IconHistory'],
                    breadcrumbs: false,
                }
                
                
            ]
        },
        {
            id: 'sample-docs-roadmap',
            type: 'group',
            children: [
                {
                    id: 'documentations',
                    title: <FormattedMessage id="documentations"/>,
                    type: 'item',
                    url: '#',
                    icon: icons['IconFileText'],
                    auth: ['public']
                  
                }
            ]
        }
    ]
};

export default menuItems;
